import React from 'react';

function TokenLocking() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900 py-8">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-bold text-white mb-8">Token Locking</h1>
        
        <div className="bg-gray-800/50 backdrop-blur-sm p-8 rounded-xl border border-purple-500/30">
          <p className="text-gray-400 text-center py-8">
            Token locking feature coming soon! Lock your tokens for bonus dividend rewards.
          </p>
        </div>
      </div>
    </div>
  );
}

export default TokenLocking;